// extracted by mini-css-extract-plugin
export default {"datepicker":"styles_datepicker__m5K+I"};